import clsx from 'clsx'
import Image from 'next/image'
import React from 'react'

import s from './styles.module.scss'

import {
  HouseContext,
  HousePictureFieldsFragment,
} from '../../../../lib/graphql'
import { NextImage, TagAutonomousBooking } from '../../../atoms'

interface HouseProps
  extends Pick<HouseContext, '_id' | 'isAutonomousBookingAvailable'> {
  coverPicture: HousePictureFieldsFragment
}

interface IHouseCardGalleryImageProps {
  house: HouseProps
  className?: string
  companyIcon?: string
  hideAutonomousBookingTag?: boolean
  siteIcon?: string
}

const HouseCardGalleryImage = ({
  house,
  className,
  companyIcon,
  hideAutonomousBookingTag = false,
  siteIcon,
}: IHouseCardGalleryImageProps) => {
  const showAutonomousBookingTag = Boolean(
    !hideAutonomousBookingTag &&
      house.isAutonomousBookingAvailable &&
      !companyIcon,
  )

  return (
    <div className={clsx(s.image, className)}>
      <NextImage
        src={house.coverPicture.uri}
        alt=''
        sizes='(max-width: 768px) 75vw, (max-width: 1200px) 40vw, 50vw'
      />
      {showAutonomousBookingTag && (
        <TagAutonomousBooking className={s.badgePosition} />
      )}
      {companyIcon && (
        <Image
          src={companyIcon}
          alt='company'
          className={s.companyIcon}
          style={{ objectFit: 'contain' }}
          width={150}
          height={50}
        />
      )}
      {siteIcon && (
        <div className={s.siteIcon}>
          <Image
            src={siteIcon}
            alt='site icon'
            style={{ objectFit: 'contain' }}
            width={18}
            height={18}
          />
        </div>
      )}
    </div>
  )
}

export default HouseCardGalleryImage
